import React from 'react';
import { useNavigate } from 'react-router-dom';
import IntroTopSection from '../../../components/Introduction/IntroTopSection';
import IntroSubHeading from '../../../components/Introduction/IntroSubHeading';

const FacilityGuidePC = () => {
  const navigate = useNavigate();

  const facilities = [
    {
      id: 1,
      title: '휴게실',
      description: '가족분들이 모여서 편안하게 쉬시고 제사 후 식사하시는 공간입니다.',
      bgImage: 'images27/e7be057a93480cc7c29775c4a1ace9369e12aff4.png'
    },
    {
      id: 2,
      title: '소나무 공원',
      description: '푹신한 잔디를 밟으며 자연의 싱그러움을 느끼실 수 있는 공간입니다.',
      bgImage: 'images27/45b39f6acb361a7a93606cf17bed92ac4310930e.png'
    },
    {
      id: 3,
      title: '주차공간',
      description: '약 300여대가 동시 주차할 수 있는 넉넉한 주차장입니다.',
      bgImage: 'images27/f06713e9ceb2befa27f422a345c1bb9e2f73ab7d.png'
    },
    {
      id: 4,
      title: '쉼터',
      description: '산에 오르기전 잠시 쉬어가실 수 있는 공간입니다.',
      bgImage: 'images27/5af7eb5e1b5bb0016cd128ee43ebfb8d686564a1.png'
    },
    {
      id: 5,
      title: '정상 팔각정',
      description: '정상에서 강화도의 경치를 감상하실 수 있습니다.',
      bgImage: 'images27/1aa9bea124207256dcdaff1d9affcd7974ae4e19.png'
    },
    {
      id: 6,
      title: '강화 유격용사 위령탑',
      description: '국가수호를 위하여 몸과 마음을 바쳤던 분들의 넋을 기리는 장소입니다.',
      bgImage: 'images27/4a4d4d4d89c69ea1d824339e36b4c915df45dcb5.png'
    }
  ];

  return (
    <div className="announcement-list-page intro-info-page">

      <IntroTopSection />

      {/* Main Content */}
      <main className="main-content">
        <IntroSubHeading heading="시설안내" />

        <div className="facility-content-section">

          <div className="features-grid">
            {facilities.map((facility) => (
              <article key={facility.id} className="feature-card">
                <div className="card-image-wrapper">
                  <img
                    src={`/${facility.bgImage}`}
                    alt={facility.title}
                    className="card-bg-image"
                  />
                  {/* <img
                    src={`/images27/${facility.id === 1 ? '1_56.svg' :
                      facility.id === 2 ? '1_64.svg' :
                        facility.id === 3 ? '1_72.svg' :
                          facility.id === 4 ? '1_80.svg' :
                            facility.id === 5 ? '1_88.svg' : '1_96.svg'}`}
                    alt=""
                    className="card-frame"
                  /> */}
                </div>
                <h3 className="card-title">{facility.title}</h3>
                <p className="card-description">{facility.description}</p>
              </article>
            ))}
          </div>
        </div>
      </main>

    </div>
  );
};

export default FacilityGuidePC; 